module.exports = __webpack_public_path__ + "static/img/gaozhongwuli4.e9484db9.jpg";